import { useState } from 'react'
import type { SearchableSelectOption } from '@/components/ui/SearchableSelect'
import type { State } from '@/lib/api/statesService'
import type {
  PropertyStaffRow,
  ResidentRow,
  TransferEmployeeSubTab,
  TransferProgressJson,
  TransferTabId,
} from '../types'

export function useTransferProcessCoreState() {
  const [processing, setProcessing] = useState(false)
  const [entityLoadStatus, setEntityLoadStatus] = useState<'pending' | 'ready' | 'failed'>('pending')
  const [states, setStates] = useState<State[]>([])
  const [propertyData, setPropertyData] = useState<Record<string, unknown> | null>(null)
  const [loadNewCompany, setLoadNewCompany] = useState<Record<string, unknown> | null>(null)
  const [companyList, setCompanyList] = useState<SearchableSelectOption[]>([])
  const [companyListOld, setCompanyListOld] = useState<SearchableSelectOption[]>([])
  const [propertyList, setPropertyList] = useState<SearchableSelectOption[]>([])
  const [companyOptionsLoading, setCompanyOptionsLoading] = useState(false)
  const [companyOldOptionsLoading, setCompanyOldOptionsLoading] = useState(false)
  const [propertyOptionsLoading, setPropertyOptionsLoading] = useState(false)
  const [allProperty, setAllProperty] = useState<Record<string, unknown>[]>([])

  const [selectedTab, setSelectedTab] = useState<TransferTabId>('propertyinfo')
  const [selectedSubTab, setSelectedSubTab] = useState<TransferEmployeeSubTab>('transferstaff')
  const [staffList, setStaffList] = useState<PropertyStaffRow[]>([])
  const [removestaffList, setRemovestaffList] = useState<PropertyStaffRow[]>([])
  const [transferstaffList, setTransferstaffList] = useState<PropertyStaffRow[]>([])
  const [addedstaffList, setAddedstaffList] = useState<PropertyStaffRow[]>([])
  const [commitstaffList, setCommitstaffList] = useState<PropertyStaffRow[]>([])

  const [selectedRemoveRoleList, setSelectedRemoveRoleList] = useState<PropertyStaffRow[]>([])
  const [selectedTransferRoleList, setSelectedTransferRoleList] = useState<PropertyStaffRow[]>([])
  const [selectedAddRoleList, setSelectedAddRoleList] = useState<PropertyStaffRow[]>([])

  const [residents, setResidents] = useState<ResidentRow[]>([])
  const [applications, setApplications] = useState<ResidentRow[]>([])
  const [residentTablesRevision, setResidentTablesRevision] = useState(0)
  const [pageOptions, setPageOptions] = useState({ current: 1, last: 1, total: 0 })
  const [pageOptionsApplication, setPageOptionsApplication] = useState({
    current: 1,
    last: 1,
    total: 0,
  })

  const [selectedResidentList, setSelectedResidentList] = useState<number[]>([])
  const [selectedApplicationList, setSelectedApplicationList] = useState<number[]>([])
  const [selectAllResidentChecked, setSelectAllResidentChecked] = useState(false)
  const [selectAllApplicationChecked, setSelectAllApplicationChecked] = useState(false)

  const [listedmanagementList, setListedmanagementList] = useState<Record<string, unknown>[]>([])

  const [infoDone, setInfoDone] = useState(false)
  const [empDone, setEmpDone] = useState(false)
  const [residentDone, setResidentDone] = useState(false)
  const [commitDone, setCommitDone] = useState(false)
  const [verifyDone, setVerifyDone] = useState(false)
  const [primaryContactSet, setPrimaryContactSet] = useState(false)

  const [domains, setDomains] = useState('')
  const [newdomains, setNewdomains] = useState('')
  const [newPropertyLabel, setNewPropertyLabel] = useState('')
  const [newPropertySave, setNewPropertySave] = useState('')
  const [residentcount, setResidentcount] = useState(0)
  const [applicantcount, setApplicantcount] = useState(0)

  const [progressData, setProgressData] = useState<TransferProgressJson>({})
  const [readOnlyControl, setReadOnlyControl] = useState<string[]>([])

  return {
    processing,
    setProcessing,
    entityLoadStatus,
    setEntityLoadStatus,
    states,
    setStates,
    propertyData,
    setPropertyData,
    loadNewCompany,
    setLoadNewCompany,
    companyList,
    setCompanyList,
    companyListOld,
    setCompanyListOld,
    propertyList,
    setPropertyList,
    companyOptionsLoading,
    setCompanyOptionsLoading,
    companyOldOptionsLoading,
    setCompanyOldOptionsLoading,
    propertyOptionsLoading,
    setPropertyOptionsLoading,
    allProperty,
    setAllProperty,
    selectedTab,
    setSelectedTab,
    selectedSubTab,
    setSelectedSubTab,
    staffList,
    setStaffList,
    removestaffList,
    setRemovestaffList,
    transferstaffList,
    setTransferstaffList,
    addedstaffList,
    setAddedstaffList,
    commitstaffList,
    setCommitstaffList,
    selectedRemoveRoleList,
    setSelectedRemoveRoleList,
    selectedTransferRoleList,
    setSelectedTransferRoleList,
    selectedAddRoleList,
    setSelectedAddRoleList,
    residents,
    setResidents,
    applications,
    setApplications,
    residentTablesRevision,
    setResidentTablesRevision,
    pageOptions,
    setPageOptions,
    pageOptionsApplication,
    setPageOptionsApplication,
    selectedResidentList,
    setSelectedResidentList,
    selectedApplicationList,
    setSelectedApplicationList,
    selectAllResidentChecked,
    setSelectAllResidentChecked,
    selectAllApplicationChecked,
    setSelectAllApplicationChecked,
    listedmanagementList,
    setListedmanagementList,
    infoDone,
    setInfoDone,
    empDone,
    setEmpDone,
    residentDone,
    setResidentDone,
    commitDone,
    setCommitDone,
    verifyDone,
    setVerifyDone,
    primaryContactSet,
    setPrimaryContactSet,
    domains,
    setDomains,
    newdomains,
    setNewdomains,
    newPropertyLabel,
    setNewPropertyLabel,
    newPropertySave,
    setNewPropertySave,
    residentcount,
    setResidentcount,
    applicantcount,
    setApplicantcount,
    progressData,
    setProgressData,
    readOnlyControl,
    setReadOnlyControl,
  }
}

export type TransferProcessCoreState = ReturnType<typeof useTransferProcessCoreState>
